import React, { useEffect, useState } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import loaderAnimation from "./Loader.lottie";

// The player is typed against a newer @types/react (ReactNode return); shim
// it for this project's React 18 types.
const DotLottiePlayer = DotLottieReact as unknown as React.FC<{
  src: string;
  loop?: boolean;
  autoplay?: boolean;
  style?: React.CSSProperties;
}>;

const Loader = () => {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(false);
    }, 3000);

    return () => {
      clearTimeout(timeout);
    };
  }, [show]);
  return (
    <>
      {show && (
        <div className="loader-wrapper">
          <DotLottiePlayer
            src={loaderAnimation}
            loop
            autoplay
            style={{ width: 100, height: 100 }}
          />
        </div>
      )}
    </>
  );
};

export default Loader;
